import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HomePage from "./pages/HomePage";

function App() {
    return (
        <Router>
            <Header />
            <Routes>
                <Route element={<HomePage />} path="/" />
            </Routes>
        </Router>
    );
}

export default App;
